<template>
  <!-- 此组件用于选择使用哪种方式渲染组件 -->
  <component
    :is="curComName"
    ref="commmon"
    :file-data="data"
    :is-smart-share="isSmartShare"
    @presentationMode="presentationMode"
    @pagechange="pagechange"
    @pagesCount="pagesCount"
  />
</template>
<script>
import bsDoctoolbar from 'components/business/pdftoolbar/doc.vue'
import bsPictoolbar from 'components/business/pdftoolbar/pic.vue'
import { getPreviewType } from 'js/util/util.js'

export default {
  name: 'Pdftoolbar',
  components: {
    bsDoctoolbar,
    bsPictoolbar,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    docCheck: {
      type: Function,
      default() {
        return true
      },
    },
    isSmartShare: {
      type: Boolean,
      default: false,
    },
    picCheck: {
      type: Function,
      default() {
        return true
      },
    },
  },
  computed: {

    /**
             * 切换不同的操作栏
             */
    curComName() {
      const metaData = this.data
      if (!metaData.neid) {
        return ''
      }
      const type = getPreviewType(metaData)
      // 目前只有三种类型的操作栏
      // （缩小， 放大，全屏） 基础
      // 1.pdf 侧栏，左切页，右切页，左旋转,右旋转
      // 2.图片 左旋转,右旋转,原图
      // 3.doc文档出execel之外的  侧栏，左切页，右切页
      // 幻灯片械，或者预览文件超过限制也不是显示底部栏的
      if (type === 'doc' && this.docCheck()) {
        if (!this.$store.state.isSideMode) { // isSideMode === false => 幻灯片模式对应'owa','owa' 没有翻页操作栏目
          return ''
        }
        return 'bsDoctoolbar'
      }
      // 图片如果不可以预览（无预览权限，大小超限），不出现操作栏
      if (type === 'image' && this.picCheck()) {
        return 'bsPictoolbar'
      }
      return ''
    },
  },
  methods: {
    /**
             * 设置页码
             */
    setPage(n) {
      if (this.$refs.commmon && this.$refs.commmon.setPage) {
        this.$refs.commmon.setPage(n)
      }
    },
    /*
             * pdfjs 对页数变化的callback
             */
    pagechange(param) {
      this.$emit('pagechange', param)
    },
    /**
             * 总页数变化
             */
    pagesCount(param) {
      this.$emit('pagesCount', param)
    },
    presentationMode(d) {
      this.$emit('presentationMode', d)
    },
  },
}
</script>
<style lang="less">
.section-control{
  line-height: 50px;
  height: 50px;
  width: 480px;
  text-align: center;
  margin: auto;
  .item-icon{
    width: 24px;
    height: 24px;
    vertical-align: middle;
  }
  .section-sidebar{
    border-radius: 2px;
    display: inline-block;
    height: 32px;
    width: 32px;
    line-height: 32px;
    text-align: center;
    margin: 0 12px 0 0;
  }
  .section-zoom-area{
    display: inline-block;
    margin: 0 12px 0 0;
    span{
      display: inline-block;
      width: 32px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border-radius: 2px;
    }
    .zoom-num{
      width: 60px;
    }
  }
  /**
    * 这里pic类用.section-rotate-pic，pdfjs类用.section-rotate-area
    * 在媒体查询时区分这两个不同的rotate区域，因为是pdf预览，会隐藏它，pic不隐藏
    */
  .section-rotate-area, .section-rotate-pic{
    display: inline-block;
    font-size: 14px;
    color: #1B2733;
    margin: 0 12px 0 0;
    .rotate-ccw, .rotate-cw{
      display: inline-block;
      width: 32px;
      height: 32px;
      line-height: 32px;
      text-align: center;
    }
    .rotate-ccw{
      margin: 0 12px 0 0;
    }
  }
  .section-page-area{
    display: inline-block;
    font-size: 14px;
    color: #1B2733;
    margin: 0 12px 0 0;
    span{
      display: inline-block;
      width: 32px;
      height: 32px;
      line-height: 32px;
      text-align: center;
    }
    .page-pre{
      margin-right: 6px;
    }
    .input-num{
      width: 38px;
      line-height: 14px;
      height: 14px;
      padding:9px 0px;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      border: none;
      letter-spacing: 0;
      background: #e8ebef;
      border-radius: 2px;
      outline:none;
      vertical-align: baseline;
    }
    .num-delimiter{
      display: inline-block;
      width: auto;
      padding: 0px 4px;
      text-align: center;
    }
    .total-num{
      width: 38px;
      vertical-align: middle;
      overflow: hidden;
      white-space:nowrap;
      text-overflow: ellipsis;
      margin-top: -3px; // 这块是因为添加overflow后，底部按钮样式不对其
    }
  }
  .section-original-pic{
    display: inline-block;
    width: auto;
    height: 32px;
    line-height: 32px;
    border-radius: 2px;
    text-align: center;
    padding: 0 8px;
    margin: 0 12px 0 0;
    .pic-text{
      color: #1B2733;
    }
  }
  .section-fullScreen{
    display: inline-block;
    width: 32px;
    height: 32px;
    line-height: 32px;
    border-radius: 2px;
    text-align: center;
  }
  .section-sidebar:hover, .zoom-in:hover, .zoom-out:hover, .rotate-ccw:hover, .rotate-cw:hover, .page-pre:hover, .page-next:hover, .section-fullScreen:hover, .section-original-pic:hover{
    background: #E8EBEF;
  }
  .section-sidebar:active, .zoom-in:active, .zoom-out:active, .rotate-ccw:active, .rotate-cw:active, .page-pre:active, .page-next:active, .section-fullScreen:active, .section-original-pic:active{
    background: #C1C7CD;
  }
  // disable original pic
  .section-original-pic-disable{
    .pic-text{
      color: #929ca9;
    }
    &:hover{
      background: none;
      color: #929CA9;
    }
    &:active{
      background: none !important;
      color: #929CA9;
    }
  }
}
</style>
